import { COULEUR_PANNEAU_DEFAUT, COULEUR_PANNEAU_SOUS_CONTRAT } from '@/configuration/configPanneau';
import siteConfig from '@/configuration/siteConfig';
import { AZIMUT } from '@/services/gestionIcon/iconMarkerConf';
import { closestMarkerColor } from '@/services/general/colorManager';

export const TAILLE_ICON_PLUS_GRAND = 70;
export const TAILLE_ICON_GRAND = 50;
export const TAILLE_ICON_PETIT = 38;
export const TAILLE_ICON_LARGEUR = 40;
export const TAILLE_ICON_HAUTEUR = 60;

const hauteurDuFichier = 2569;
const largeurDuFichier = 530;


function findAzimut(azimut) {
  const result = AZIMUT.find((option) => {
    return (azimut >= option.min && azimut <= option.max)
      || (option.min2 && azimut >= option.min2 && option.max2 && azimut <= option.max2);
  });
  if (result) return result.value;
  return 0;
}

function roundRect(context, x, y, w, radius, color) {
  const h = w;
  const r = x + w;
  const b = y + h;
  context.beginPath();
  context.strokeStyle= color ? color : "green";
  context.fillStyle=color;
  context.lineWidth="4";
  context.moveTo(x+radius, y);
  context.lineTo(r-radius, y);
  context.quadraticCurveTo(r, y, r, y+radius);
  context.lineTo(r, y+h-radius);
  context.quadraticCurveTo(r, b, r-radius, b);
  context.lineTo(x+radius, b);
  context.quadraticCurveTo(x, b, x, b-radius);
  context.lineTo(x, y+radius);
  context.quadraticCurveTo(x, y, x+radius, y);
  context.fill();
}

function getPositionCouleurMarker(couleur) {
  return closestMarkerColor(couleur || COULEUR_PANNEAU_DEFAUT).id;
}

export function iconColorGetter(colorDemande, tailleDemande, azimutDemande, afficherAzimut) {
  const color = colorDemande || COULEUR_PANNEAU_DEFAUT;
  let taille = tailleDemande;
  if (!taille) {
    taille = TAILLE_ICON_PETIT;
  }
  let azimut = azimutDemande;
  if (azimut === null || azimut === undefined || !afficherAzimut) {
    azimut = 'aucun';
  }
  azimut = findAzimut(azimut);
  const ratio = taille / TAILLE_ICON_HAUTEUR;
  const positionCouleur = getPositionCouleurMarker(color);
  return {
    url: require('@/assets/images/icon/icons.png'),
    scaledSize: { width: largeurDuFichier * ratio, height: hauteurDuFichier * ratio, f: 'px', b: 'px' },
    size: { width: TAILLE_ICON_LARGEUR * ratio, height: taille, f: 'px', b: 'px' },
    origin: { x: azimut * TAILLE_ICON_LARGEUR * ratio, y: positionCouleur * TAILLE_ICON_HAUTEUR * ratio, f: 'px', b: 'px' },
  };
}

export function getIconPanneau(panneau) {
  const { categorie, azimut, estRenouvellement } = panneau;
  if (estRenouvellement) {
    return iconColorGetter(COULEUR_PANNEAU_SOUS_CONTRAT, TAILLE_ICON_GRAND, azimut, true);
  }
  if (categorie) {
    return iconColorGetter(categorie.couleur, TAILLE_ICON_GRAND, azimut, true);
  }
  return iconColorGetter(COULEUR_PANNEAU_DEFAUT, TAILLE_ICON_GRAND, azimut, true);
}

export function iconPointDeVente(img, cote, color) {
  const { anchorIcon } = (siteConfig.default).pdv;
  const canvas = document.createElement('canvas');
  const width = cote - 5;
  const height = cote;
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  const radius = 0;
  const coteCarre = width - 2 * radius;
  roundRect(ctx, radius, radius, coteCarre, radius, color);
  ctx.strokeStyle = color ? color: '';
  if (anchorIcon) {
    ctx.beginPath();
    ctx.moveTo(width / 2 - 6, width);
    ctx.lineTo(width / 2, height);
    ctx.lineTo(width / 2 + 6, height - (height - width));
    ctx.closePath();
    ctx.fill();
  }
  const border = 2;
  const widthImage = img.naturalWidth ? img.naturalWidth : cote;
  const heigthImage = img.naturalHeight ? img.naturalHeight : cote;
  ctx.drawImage(img, 0, 0, widthImage, heigthImage, border, border, width - border * 2, width - border * 2);
  return canvas.toDataURL('image/png');
}

export async function iconMarkerInfoBulle(couleur, azimut, index) {
  // Récupération de l'image contenant toute les icônes
  const img = new Image(largeurDuFichier, hauteurDuFichier);
  img.src = require('@/assets/images/icon/icons.png');

  // Attendre que l'image soit chargée
  await new Promise((resolve) => {
    img.onload = resolve;
  });

  const rayon = 12;  // Rayon du cercle contenant le numéro du panneau

  // Création d'un objet canvas
  const canvas = document.createElement('canvas');
  const width = TAILLE_ICON_LARGEUR + rayon;  // Définition de la largeur du canvas
  const height = TAILLE_ICON_HAUTEUR + rayon;  // Définition de la hauteur du canvas
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  // Position du marqueur dans le canvas
  const x = findAzimut(azimut) * TAILLE_ICON_LARGEUR;
  const y = getPositionCouleurMarker(couleur) * TAILLE_ICON_HAUTEUR;

  // Dessin de l'image dans le canvas
  ctx.drawImage(img, x, y, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR, 0, rayon, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR);

  // Centre du cercle contenant le numéro du panneau
  const centreX = TAILLE_ICON_LARGEUR;
  const centreY = rayon + 5;

  // Dessin du cercle qui contiendra le numéro du panneau
  ctx.beginPath();
  ctx.arc(centreX, centreY, rayon, 0, Math.PI * 2, true);
  ctx.fillStyle = '#2C3E50';
  ctx.fill();

  // Insertion du numéro du panneau, centré dans le cercle
  const numero = `${index}`;
  const largeurDisponible = (rayon - 2) * 2;
  let taillePolice = 17;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = 'white';
  ctx.font = `bold ${taillePolice}px sans-serif`;
  // Réduction de la police tant que le numéro déborde du cercle (2 chiffres et plus)
  while (taillePolice > 8 && ctx.measureText(numero).width > largeurDisponible) {
    taillePolice -= 1;
    ctx.font = `bold ${taillePolice}px sans-serif`;
  }
  ctx.fillText(numero, centreX, centreY);

  // Retour du canvas sous forme d'image png
  const dataURL = canvas.toDataURL('image/png');
  return dataURL;
}

export async function getIconPdvData(url, width, height, color) {
  const { widthIcon, colorIcon, getGoogleAnchor } = (siteConfig.default).pdv;
  const w = width || widthIcon;
  const h = height || widthIcon;
  const c = color !== undefined ? color : colorIcon;
  return new Promise(resolve => {
    const img = document.createElement('img');
    img.onload = () => {
      const logo = iconPointDeVente(img, w, c);
      const icon = {
        url: logo,
        scaledSize: new google.maps.Size(w, h),
        origin: new google.maps.Point(0, 0),
        anchor: getGoogleAnchor(w, h),
      };
      resolve({
        icon,
        data: logo,
        width: img.width,
      });
    };
    img.onerror = () => {
      img.src = require('@/assets/images/general/default_img.png');
    };
    img.setAttribute('src', url);
    img.setAttribute('crossOrigin', 'Anonymous');
  })
}
